import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { expenseEndpoints } from '@/lib/api/endpoints';
import { expenseKeys } from '@/lib/queryKeys';
import type { JobProfitability } from '@/types/settings';

export function useJobProfitability(jobId: string) {
  return useApiQuery<JobProfitability>({
    queryKey: expenseKeys.profitability(jobId),
    queryFn: () =>
      apiGet<JobProfitability>(operationsClient, expenseEndpoints.profitability(jobId)),
    enabled: Boolean(jobId),
    showErrorToast: false,
  });
}
